// import React from "react";
// import s1 from "../assets/s1.png";
// import si1 from "../assets/si1.png";
// import si2 from "../assets/si2.png";
// import si3 from "../assets/si3.png";
// import PhoneHeader from "./PhoneHeader";

// const TaxationService = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },

//   ];
//   return (
//     <>
//     <PhoneHeader title="Taxation Services" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div className="text-center top-heading section">
//           <h1>Taxation Services</h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//            <div className="row justify-content-center g-4">
//             <h2
//             className="mt-4 mb-5"
//             style={{ textAlign: "center", fontWeight: "600" }}
//           >
//             Services Include
//           </h2>
//         {/* GST Registration & Returns */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#FFDED3" }}>
//             <img src={si1} alt="GST Registration & Returns" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">GST Registration & Returns</h5>
//             <p>GST registration & return filing <br /> paymenthub</p>
//           </div>
//         </div>

//         {/* Income Tax Return (ITR) */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#E0FBFF" }}>
//             <img src={si2} alt="Income Tax Return" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Income Tax Return (ITR)</h5>
//             <p>Income tax return (ITR) filing <br /> paymenthub.</p>
//           </div>
//         </div>

//         {/* Network & Maintenance */}
//         <div className="col-12 col-sm-6 col-md-4">
//           <div className="p-4 text-center rounded-4" style={{ backgroundColor: "#EBF4E7" }}>
//             <img src={si3} alt="Network & Maintenance" className="mb-3 img-fluid" />
//             <h5 className="fw-semibold">Network & Maintenance</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//           </div>
//         </div>
//       </div>

//         {/* benefits */}
//         <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Save time with digital filing.
//                   </h5>
//                   <p className="text-start">
//                     One-stop bill payment portal for multiple services.{" "}
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">
//                     Expert guidance so you don’t make mistakes.
//                   </h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Affordable service suited for small businesses, retailers,
//                     or agents.
//                   </h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled
//                     like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TaxationService;
import React from "react";
import s1 from "../assets/s1.png";
import as4 from "../assets/as4.png";
import as1 from "../assets/as1.png";
import as2 from "../assets/as2.png";
import as3 from "../assets/as3.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import v8 from "../assets/Vector 8.png";
import hiw1 from "../assets/hiw1.png";
import hiw2 from "../assets/hiw2.png";
import hiw3 from "../assets/hiw3.png";
import hiw4 from "../assets/hiw4.png";
import hiw5 from "../assets/hiw5.png";
import vs from "../assets/Vector8.png";
import PhoneHeader from "./PhoneHeader";

const TaxationService = () => {
  const data = [
    {
      title: "Financial Inclusion",
      text: "Brings banking to remote or rural areas without branches.",
    },
    {
      title: "Secure & Reliable",
      text: "Uses Aadhaar authentication, reducing fraud risk.",
    },
    {
      title: "No Card Required",
      text: "Works without debit/credit cards or smartphones in some cases.",
    },
    {
      title: "Commission for Agents",
      text: "Agents / BCs can earn commission on each transaction.",
    },
  ];
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">Taxation Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong> */}
              Our Taxation Services are designed to simplify financial compliance
              for individuals, retailers, and businesses associated with AEPS
              and digital payment services. We provide end-to-end tax support to
              ensure accurate filing, timely submissions, and complete
              transparency, helping you stay compliant with government
              regulations while focusing on business growth.
            </p>
            <ul class="list-unstyled mb-4 mb-md-0">
              <h5 className="fw-bold mt-2 mb-3">What We Offer</h5>
              <li className="mb-2">• Income Tax Filing</li>
              <li className="mb-2">• GST Registration & Filing</li>
              <li className="mb-2">• Business Tax Compliance</li>
              <li className="mb-2">• PAN Card Services</li>
              <li className="mb-2">• Financial Advisory for AEPS Retailers</li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3", padding: "36px" }}
        >
          <div className="col-12 col-md-6 mb-4 mb-md-0 d-md-block d-none">
            <img src={solution} alt="solution" className="img-fluid" />
          </div>

          <div className="col-12 col-md-6 m-auto">
            <h2 className="mb-md-5 mb-4 center" style={{ fontWeight: "700" }}>
              Why Choose Our Taxation Services?
            </h2>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution1} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Accurate and Hassle-Free Filing
                </h6>
                <p className="mb-0">
                  Avoid penalties and errors with expert tax handling.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution2} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Affordable for Small Retailers & Agents
                </h6>
                <p className="mb-0">
                  Designed especially for AEPS retailers, CSC operators, and
                  small entrepreneurs.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution3} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Secure & Confidential
                </h6>
                <p className="mb-0">
                  Your financial data is handled with strict security and
                  privacy standards.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution4} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  End-to-End Support
                </h6>
                <p className="mb-0">
                  From registration to filing, we manage everything for you.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Who Can Use Our Taxation Services?
          </h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center  mb-4 mb-md-0">
              <img
                src={s1}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%" , width: "100%"}}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7">
              <ul className="list-unstyled mx-auto">
                <li className=" mb-3">• AEPS retailers & super distributors</li>
                <li className=" mb-3">• Fintech service providers</li>
                <li className=" mb-3">• Shop owners & freelancers</li>
                <li className=" mb-3">• Small and medium businesses</li>
                <li className="">• Individuals needing tax assistance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxationService;
